/*!
 *  2017-12-14 14:48:30
 *  Copyright 2017 FT, DK Techin Corp 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _define = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $ctx = (0, _jquery2['default'])('#brcColl');
	var $linkTag = $ctx.find('.link_tag');
	var TAG_PARAM_NAME = 'brunch_tag';
	var TAG_MAX_HEIGHT = $ctx.find('.tab_tag').height() * 2;
	var tagParam = SF.getParam(TAG_PARAM_NAME);
	var page = _define.EXPAND.START_OF_PAGE;
	
	function ExpandAPIUrl(p) {
	  var params = {
	    m: "BRC",
	    query: decodeURIComponent(window.utf8Query),
	    p: p,
	    type: 'list'
	  };
	  if (tagParam) {
	    params[TAG_PARAM_NAME] = tagParam;
	  }
	  return SF.getQsUrl(params, 2);
	}
	
	var pager = new SF.pager({
	  navigation: (0, _jquery2['default'])('#brcColl .coll_tit > .paging_nav'),
	  list: (0, _jquery2['default'])('#brcColl .coll_recomm .cont_info'),
	  viewCount: 1,
	  isInfinite: false
	});
	
	function setTab(self) {
	  console.log('test');
	  self.parent().find('li').removeClass('on');
	  self.addClass('on');
	}
	
	$ctx.find('.expender').on('click', function (e) {
	
	  (0, _jquery2['default'])(this).hasClass('close') ? smartLog(this, _define.EXPAND.LOG_FOLD, e) : smartLog(this, _define.EXPAND.LOG_EXPAND, e);
	});
	
	var extendModule = new SF.extend({
	  container: $ctx.find('.list_brunch'),
	  expender: $ctx.find('.extend_comp'),
	  viewCount: 3,
	  source: function source(response) {
	    _jquery2['default'].ajax({
	      url: ExpandAPIUrl(page),
	      dataType: 'html',
	      success: function success(data, textStatus) {
	        page += 1;
	        onComplete(data, textStatus, response);
	      },
	      error: function error(jqXHR, textStatus) {
	        onError(jqXHR, textStatus, response);
	      }
	    });
	  }
	});
	
	function isEnd($html) {
	  return $html.find('.' + _define.EXPAND.FLAG_IS_END).length > 0 || page === _define.EXPAND.END_OF_PAGE;
	}
	
	function onComplete(html, textStatus, response) {
	  if (textStatus === 'success') {
	    var $htmlWrapper = (0, _jquery2['default'])('<div></div>').append(html);
	    response($htmlWrapper.find('li'), isEnd($htmlWrapper));
	  } else {
	    onError(null, textStatus, response);
	  }
	}
	
	function onError(jqXHR, textStatus, response) {
	  page -= 1;
	  response(null);
	  throw new Error(textStatus);
	}
	
	function tagMore() {
	  var tagTab = $ctx.find('.item_tag').height();
	  if (tagTab < TAG_MAX_HEIGHT) {
	    $linkTag.hide();
	  }
	}
	
	function tagTabMoreEvt() {
	  $linkTag.on('click', function (e) {
	    var $this = (0, _jquery2['default'])(this);
	    var $tag = $ctx.find('.tab_tag');
	    var arrowIco = '<span class="ico_brc"></span>';
	
	    if ($tag.hasClass('fold_tag')) {
	      $tag.removeClass('fold_tag');
	      $this.html('더보기' + arrowIco);
	      smartLog(this, _define.EXPAND.MORE_FOLD, e);
	    } else {
	      $tag.addClass('fold_tag');
	      $this.html('접기' + arrowIco);
	      smartLog(this, _define.EXPAND.MORE_EXPAND, e);
	    }
	  });
	}
	
	tagTabMoreEvt();
	tagMore();

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXPAND = exports.DEFINE_MIDDLE = undefined;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DEFINE_MIDDLE_NAME_SPACE = 'brunchColl';
	
	var DEFINE_MIDDLE = exports.DEFINE_MIDDLE = C[DEFINE_MIDDLE_NAME_SPACE]['data'];
	var EXPAND = exports.EXPAND = {
	  END_OF_PAGE: 6,
	  START_OF_PAGE: 2,
	  FLAG_IS_END: 'end_of_list',
	  LOG_EXPAND: _jquery2['default'].param({
	    s: 'TO',
	    a: DEFINE_MIDDLE.LOG_CODE,
	    dc: DEFINE_MIDDLE.DA,
	    at: 'func',
	    e: 2
	  }),
	  LOG_FOLD: _jquery2['default'].param({
	    s: 'TO',
	    a: DEFINE_MIDDLE.LOG_CODE,
	    dc: DEFINE_MIDDLE.DA,
	    at: 'func',
	    e: 3
	  }),
	  MORE_EXPAND: _jquery2['default'].param({
	    s: 'TO',
	    a: DEFINE_MIDDLE.LOG_CODE,
	    dc: DEFINE_MIDDLE.DA,
	    at: 'func',
	    e: 4
	  }),
	  MORE_FOLD: _jquery2['default'].param({
	    s: 'TO',
	    a: DEFINE_MIDDLE.LOG_CODE,
	    dc: DEFINE_MIDDLE.DA,
	    at: 'func',
	    e: 5
	  })
	};

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** brunch/brunch.bundle.1c9fd76.js
 **/